import React, { Fragment, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import CardProductionSystem from "./CardProductionSystem";
import CardTemplateManager from "./CardTemplateManager";
import CardBatchManager from "./CardBatchManager";
import CardStockManager from "./CardStockManager";

const CartesProductionPage = () => {
  const [activeTab, setActiveTab] = useState('production');

  return (
    <Fragment>
      <PageTitle activeMenu="Production des Cartes" motherMenu="Cartes" />
      
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-4">
                
                <Tab eventKey="production" title={
                  <span>
                    <i className="la la-play me-2"></i>
                    Initier Production
                  </span>
                }>
                  <CardProductionSystem />
                </Tab>

                <Tab eventKey="templates" title={
                  <span>
                    <i className="la la-id-card me-2"></i>
                    Templates
                  </span>
                }>
                  <CardTemplateManager />
                </Tab>

                <Tab eventKey="batches" title={
                  <span>
                    <i className="la la-boxes me-2"></i>
                    Lots de Production
                  </span>
                }>
                  <CardBatchManager />
                </Tab>

                {/* <Tab eventKey="stock" title={
                  <span>
                    <i className="la la-warehouse me-2"></i>
                    Gestion Stock
                  </span>
                }>
                  <CardStockManager />
                </Tab> */}

              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CartesProductionPage;